import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { ProfilePageComponent } from '../component/page/user/profile-page/profile-page.component';
import { RegisterPageComponent } from '../component/page/user/register-page/register-page.component';
import { UserRegistrationThankyouPageComponent } from '../component/page/user/user-registration-thankyou-page/user-registration-thankyou-page.component';
import { AuthGuardService } from '../service/auth-guard.service';

const routes: Routes = [
  { path: 'account/register', component: RegisterPageComponent, canActivate: [AuthGuardService] },
  { path: 'profile', component: ProfilePageComponent, canActivate: [AuthGuardService] },
  { path: 'account/user-register-thank-you', component: UserRegistrationThankyouPageComponent, canActivate: [AuthGuardService] }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppUserRoutingModule {}
